"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var isIndexPath_exports = {};
__export(isIndexPath_exports, {
  isIndexPath: () => isIndexPath
});
module.exports = __toCommonJS(isIndexPath_exports);
function isIndexPath(state) {
  var _state_index;
  if (!state.routes) {
    return false;
  }
  var route = getActualLastRoute(state.routes[(_state_index = state.index) !== null && _state_index !== void 0 ? _state_index : state.routes.length - 1]);
  if (route.state) {
    return isIndexPath(route.state);
  }
  if (route.name === "index") {
    return true;
  }
  if (route.params && "screen" in route.params) {
    return route.params.screen === "index";
  }
  if (route.name.match(/.+\/index$/)) {
    return true;
  }
  return false;
}
function getActualLastRoute(routeLike) {
  var _routeLike_state;
  if (routeLike.name[0] === "(" && ((_routeLike_state = routeLike.state) === null || _routeLike_state === void 0 ? void 0 : _routeLike_state.routes)) {
    var _routeLike_state_index;
    var routes = routeLike.state.routes;
    return getActualLastRoute(routes[(_routeLike_state_index = routeLike.state.index) !== null && _routeLike_state_index !== void 0 ? _routeLike_state_index : routes.length - 1]);
  }
  return routeLike;
}
//# sourceMappingURL=isIndexPath.js.map
